import { Icon, IconProps } from "@chakra-ui/react";
import React from "react";

const DateIcon = (props: IconProps): JSX.Element => (
  <Icon
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.33333 1.5C5.60948 1.5 5.83333 1.72386 5.83333 2V2.83333H10.1667V2C10.1667 1.72386 10.3905 1.5 10.6667 1.5C10.9428 1.5 11.1667 1.72386 11.1667 2V2.83333H12.6667C13.6792 2.83333 14.5 3.65415 14.5 4.66667V12.6667C14.5 13.6792 13.6792 14.5 12.6667 14.5H3.33333C2.32082 14.5 1.5 13.6792 1.5 12.6667V4.66667C1.5 3.65414 2.32081 2.83333 3.33333 2.83333H4.83333V2C4.83333 1.72386 5.05719 1.5 5.33333 1.5ZM4.83333 3.83333H3.33333C2.8731 3.83333 2.5 4.20643 2.5 4.66667V12.6667C2.5 13.1269 2.87309 13.5 3.33333 13.5H12.6667C13.1269 13.5 13.5 13.1269 13.5 12.6667V4.66667C13.5 4.20642 13.1269 3.83333 12.6667 3.83333H11.1667V4.66667C11.1667 4.94281 10.9428 5.16667 10.6667 5.16667C10.3905 5.16667 10.1667 4.94281 10.1667 4.66667V3.83333H5.83333V4.66667C5.83333 4.94281 5.60948 5.16667 5.33333 5.16667C5.05719 5.16667 4.83333 4.94281 4.83333 4.66667V3.83333ZM4.16667 7.33333C4.16667 7.05719 4.39052 6.83333 4.66667 6.83333H11.3333C11.6095 6.83333 11.8333 7.05719 11.8333 7.33333C11.8333 7.60948 11.6095 7.83333 11.3333 7.83333H4.66667C4.39052 7.83333 4.16667 7.60948 4.16667 7.33333Z"
      fill="currentColor"
    />
  </Icon>
);

export default DateIcon;
